// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__284m0","label":"Category_label__1SmyW","content":"Category_content__b9mFF","header":"Category_header__2of3H","location":"Category_location__1RcJd"};